(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    ;
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop <= this.headerBounds.top) {
        // Back at the very top — restore the natural (non-sticky) state
        requestAnimationFrame(this.reset.bind(this));
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling DOWN past the header — slide it away
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop) {
        // Scrolling UP anywhere below the top — slide it back in
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Logic for search box toggle
  // (function () {
  //  document.querySelector('.header__search .search-modal').style.display = '';
  //  document.querySelector('.header__icon--search-mobile').addEventListener("click", function() {
  //    event.preventDefault();
  //    const parent = document.querySelector('.header__search');
  //    parent.classList.remove('hidden');
      
  //    parent.querySelector('details').setAttribute("open", "true");
  //  });

  //  document.querySelector('.search-modal__close-button').addEventListener("click", function() {
  //    const parent = document.querySelector('.header__search');
  //    parent.classList.add('hidden');
  //  });

    
  // })();

  // Submenu drawer logic
  (function () {
    const panels = [
      {
        panel: document.getElementById('drawer-submenu-panel'),
        backBtn: document.getElementById('drawer-submenu-back'),
        titleEl: document.getElementById('drawer-submenu-title'),
        listEl: document.getElementById('drawer-submenu-list'),
        openClass: 'drawer-submenu-panel--open'
      },
      {
        panel: document.getElementById('desktop-drawer-submenu-panel'),
        backBtn: document.getElementById('desktop-drawer-submenu-back'),
        titleEl: document.getElementById('desktop-drawer-submenu-title'),
        listEl: document.getElementById('desktop-drawer-submenu-list'),
        openClass: 'desktop-submenu-panel--open'
      }
    ].filter(p => p.panel);

    if (panels.length === 0) return;

    function getActivePanelData() {
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;
      // Use the desktop panel if we're on desktop and it exists; otherwise use mobile panel
      const desktopPanel = panels.find(p => p.openClass === 'desktop-submenu-panel--open');
      const mobilePanel = panels.find(p => p.openClass === 'drawer-submenu-panel--open');
      return (isDesktop && desktopPanel) ? desktopPanel : mobilePanel;
    }

    // Open: populate panel with child links for the clicked parent handle
    document.querySelectorAll('.menu-drawer__menu-item.link-level-1').forEach(parentLink => {
      parentLink.addEventListener('click', (e) => {
        e.preventDefault();

        const handle   = parentLink.dataset.handle;
        const children = document.querySelectorAll(`li[data-handle="${handle}"]`);

        if (!children.length) {
          window.location.href = parentLink.href;
          return;
        }

        const activePanelData = getActivePanelData();
        if (!activePanelData) return;
        const { panel, titleEl, listEl, openClass } = activePanelData;

        // Toggle: if this panel is already open for the same parent, close it
        const isOpen = panel.classList.contains(openClass);
        const parentTitle = parentLink.childNodes[0].textContent.trim() || parentLink.firstElementChild?.textContent.trim() || '';
        const sameTitle = titleEl.textContent === parentTitle;
        if (isOpen && sameTitle) {
          panel.classList.remove(openClass);
          panel.setAttribute('aria-hidden', 'true');
          // Clear after transition to avoid flash
          panel.addEventListener('transitionend', () => {
            listEl.innerHTML = '';
            titleEl.textContent = '';
          }, { once: true });
          return;
        }

        // Set the panel title to the parent link's text (strip the chevron span)
        titleEl.textContent = parentLink.childNodes[0].textContent.trim() || parentLink.firstElementChild?.textContent.trim() || '';

        // Clear previous children and populate with clones
        listEl.innerHTML = '';
        children.forEach(li => {
          const clone = li.cloneNode(true);
          clone.classList.remove('hidden');
          listEl.appendChild(clone);
        });

        // Slide in
        panel.classList.add(openClass);
        panel.setAttribute('aria-hidden', 'false');
      });
    });

    function removeEnSubpath(pathname) {
      const segments = pathname.split('/').filter(Boolean);
      if (segments.length && segments[0].startsWith('en-')) {
        segments.shift(); // remove first segment
      }
      return '/' + segments.join('/');
    }

    // Handle currency item clicks in any slide-in panel (mobile + desktop)
    function handleCurrencyClick(e) {
      const currencyItem = e.target.closest('[data-currency]');
      if (!currencyItem) return;
      const country = currencyItem.dataset.country;
      const newPath = removeEnSubpath(window.location.pathname);
      const countryPath = country && country !== '' ? `/${country}` : '';
      window.location.href = `${countryPath}${newPath}`;
    }

    panels.forEach(({ listEl }) => {
      if (listEl) listEl.addEventListener('click', handleCurrencyClick);
    });

    // Reset all panels when the drawer closes (overlay click, Escape key, close button, etc.)
    const drawerDetails = document.getElementById('Details-menu-drawer-container');
    if (drawerDetails) {
      drawerDetails.addEventListener('toggle', () => {
        if (!drawerDetails.open) {
          // Drawer just closed — reset every panel immediately (no animation needed)
          panels.forEach(({ panel, listEl, titleEl, openClass }) => {
            panel.classList.remove(openClass);
            panel.setAttribute('aria-hidden', 'true');
            listEl.innerHTML = '';
            if (titleEl) titleEl.textContent = '';
          });
        }
      });
    }

    // Close: slide the panel back out and clear it
    panels.forEach(({ panel, backBtn, listEl, titleEl, openClass }) => {
      if(backBtn !== null) {
        backBtn.addEventListener('click', () => {
          panel.classList.remove(openClass);
          panel.setAttribute('aria-hidden', 'true');
          // Clear after transition so there's no flash of old content
          panel.addEventListener('transitionend', () => {
            listEl.innerHTML = '';
            titleEl.textContent = '';
          }, { once: true });
        });
      }
    });

    // Set current currency label(s) based on URL subpath
    const subpath = window.location.pathname.split('/')[1];
    if (subpath && subpath.startsWith('en-')) {
      // Find matching country entry
      const currencyList = document.querySelectorAll('[data-country]');
      currencyList.forEach((item) => {
        if (item.dataset.country === subpath) {
          // Update all .currency-current elements (drawer heading + any clones)
          document.querySelectorAll('.currency-current').forEach((el) => {
            el.textContent = item.dataset.currency;
          });
        }
      });
    }

  })();

  (() => {
    const announcementMessage = document.querySelector('.announcement-bar__message-mobile');
    const speed = 100;

    const duration = announcementMessage.offsetWidth / speed;
    announcementMessage.style.animationDuration = `${duration}s`;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  class WelcomePopup extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector("#welcome_popup");
      this.opened = false;

      if (this.dialog) {
        this.fullpageHeight = document.body.scrollHeight - window.innerHeight;
        this.closeButton = this.querySelectorAll(".popup_close,button.newsletter_close");

        this.closeButton.forEach(function(button){
          button.addEventListener('click', this.onDialogClick.bind(this));
        }.bind(this));
        window.addEventListener('scroll', this.onScrollOpen.bind(this));
      }
    }

    onScrollOpen(event) {
      if (window.scrollY/this.fullpageHeight > 0.6) {
        if (this.opened == false) this.dialog.showModal();
        this.opened = true;
      }
    }
    
    onDialogClick(event) {
      this.dialog.close();
    }
  }

  customElements.define('welcome-popup', WelcomePopup);

  } catch(e) { console.error(e); }
})();
})();
